import { render, staticRenderFns } from "./candidateEvaluations.vue?vue&type=template&id=cbbf1af4&"
import script from "./candidateEvaluations.vue?vue&type=script&lang=js&"
export * from "./candidateEvaluations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports